var _excluded = ["type", "slug", "newListingsSlug"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isEmpty } from 'lodash';
import { LocalityType, LocalityTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { isA } from '../../utils/testing';
import { BaseSearchQueryField } from '../base-search-query-field';
import { findAlias, CanberraQueanbeyan, localityAliases } from './locality-aliases';
var toLocalityIdentifier = function toLocalityIdentifier(type) {
  var idOrSlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return _objectSpread({
    type
  }, typeof idOrSlug === 'number' || idOrSlug.match(/^\d+(-primary|-secondary)?$/) ? {
    id: idOrSlug
  } : {
    slug: idOrSlug
  });
};
var isSlugIdentifier = value => !isEmpty(value.slug);
var toLocalityIdentifierArray = (stringList, type) => stringList && typeof stringList === 'string' ? stringList.split(',').filter(each => each).map(each => toLocalityIdentifier(type, each)) : [];
var mergeLocalityIdentifiers = (list, locality) => locality ? [...list.filter(each => !(locality && each.type === locality.type && (each.id && "".concat(each.id) === "".concat(locality.id) || each.slug && each.slug === locality.slug))), locality] : [...list];
var toMinimalIdentifier = value => isSlugIdentifier(value) ? {
  type: value.type,
  slug: value.slug
} : {
  type: value.type,
  id: value.id
};
export var DefaultLocalities = CanberraQueanbeyan.localities;
export var DefaultLocalityIdentifiers = DefaultLocalities.map(locality => toMinimalIdentifier(locality));
var localitiesMatch = (a, b) => a.length === b.length && a.every(_ref => {
  var id = _ref.id,
    type = _ref.type,
    slug = _ref.slug;
  return b.find(dflt => dflt.slug === slug || dflt.id === id && dflt.type === type);
});
var aliasFromLocalities = localities => localityAliases.find(alias => localitiesMatch(alias.localities, localities));
var validateLocalityInputIdentifiers = input => {
  if (!(input !== null && input !== void 0 && input.id) && !(input !== null && input !== void 0 && input.slug) && !(input !== null && input !== void 0 && input.newListingsSlug)) {
    return [];
  }
  if (input.slug || input.newListingsSlug) {
    var alias = findAlias(input);
    if (alias) {
      return alias.localities.map(locality => ({
        type: locality.type,
        id: locality.id,
        slug: locality.slug
      }));
    }
  }
  var type = input.type,
    slug = input.slug,
    newListingsSlug = input.newListingsSlug,
    rest = _objectWithoutProperties(input, _excluded);
  var resolvedSlug = slug || newListingsSlug;
  var resolvedType = LocalityTypeKeys.find(key => key.toLowerCase() === (type === null || type === void 0 ? void 0 : type.toLowerCase()));
  if (!resolvedType && !resolvedSlug) {
    return [];
  }
  return [_objectSpread({
    slug: resolvedSlug,
    type: resolvedType
  }, rest)];
};
var resolveLocalityInputIdentifiers = input => {
  if (!input) {
    return null;
  }
  return input.flatMap(validateLocalityInputIdentifiers).filter(each => each != null);
};
export class Localities extends BaseSearchQueryField {
  constructor(searchOptions, inputValue) {
    var localities = Localities.isInstance(inputValue) ? inputValue.value : resolveLocalityInputIdentifiers(inputValue);
    super(searchOptions, localities, DefaultLocalities);
  }
  get value() {
    return this.internalValue || [];
  }
  get urlSlugs() {
    return Object.values(LocalityType).map(type => type.urlSlug);
  }
  isLocalities() {
    return true;
  }
  isDefault() {
    var _this$default;
    return localitiesMatch((_this$default = this.default) !== null && _this$default !== void 0 ? _this$default : [], this.value);
  }
  getUrlValuesByType(type) {
    var localities = this.byType(type);
    if (isEmpty(localities)) {
      return null;
    }
    return {
      [LocalityType[type].urlSlug]: localities.map(loc => loc.slug || loc.id).sort().join(',')
    };
  }
  toUrlParameters() {
    if (this.isDefault()) {
      return [];
    }
    var alias = aliasFromLocalities(this.value);
    if (alias) {
      return [];
    }
    return [this.getUrlValuesByType('REGION'), this.getUrlValuesByType('DISTRICT'), this.getUrlValuesByType('DIVISION'), this.getUrlValuesByType('STREET'), this.getUrlValuesByType('POSTCODE'), this.getUrlValuesByType('SCHOOL')].filter(each => each != null);
  }
  byType(type) {
    return this.value.filter(each => !type || each.type === type);
  }
  getSingleValue() {
    var alias = aliasFromLocalities(this.value);
    if (alias) {
      return alias;
    }
    return this.value.length === 1 ? this.value[0] : null;
  }
  getMinimalIdentifiers() {
    return this.value.map(toMinimalIdentifier);
  }
  getCondensedValue() {
    return this.getMinimalIdentifiers();
  }
  isEmpty() {
    return this.value.length === 0;
  }
  static isInstance(obj) {
    return isA(obj, 'Localities');
  }
  static fromUrlParameters(searchOptions, q, _ref2) {
    var divisionName = _ref2.divisionName,
      postcode = _ref2.postcode,
      listingState = _ref2.listingState,
      localitySlug = _ref2.localitySlug;
    if (localitySlug) {
      return new Localities(searchOptions, [{
        newListingsSlug: localitySlug
      }]);
    }
    var suburbs = divisionName ? "".concat(divisionName, "-").concat(listingState, "-").concat(postcode, ",").concat(q.suburb || '') : q.suburb;
    var localities = mergeLocalityIdentifiers([...toLocalityIdentifierArray(q.region, 'REGION'), ...toLocalityIdentifierArray(q.district, 'DISTRICT'), ...toLocalityIdentifierArray(suburbs, 'DIVISION'), ...toLocalityIdentifierArray(q.postcode, 'POSTCODE'), ...toLocalityIdentifierArray(q.street, 'STREET'), ...toLocalityIdentifierArray(q.school, 'SCHOOL')]);
    return new Localities(searchOptions, localities.length ? localities : null);
  }
  static fromQueryObject(searchOptions, _ref3) {
    var divisionId = _ref3.divisionId,
      filters = _ref3.filters;
    var _ref4 = filters || {},
      localitiesOrIdentifiers = _ref4.localities;
    if (divisionId == null && localitiesOrIdentifiers == null) {
      return new Localities(searchOptions, null);
    }
    var localities = Localities.isInstance(localitiesOrIdentifiers) ? localitiesOrIdentifiers.value : localitiesOrIdentifiers;
    var filteredLocalities = [...(divisionId ? [toLocalityIdentifier('DIVISION', divisionId)] : []), ...(localities || []).filter(each => !(divisionId && each.type === 'DIVISION' && each.id === divisionId))];
    return new Localities(searchOptions, filteredLocalities);
  }
}